module.exports = __webpack_public_path__ + "img/ic-diario.f5696a91.png";